import React, { useEffect, useMemo, useRef } from 'react';
import M from 'materialize-css';

const DropdownMenu = ({ name, field, filterValue, options, onSelect, required }) => {
    const dropdownRef = useRef(null);

    const uniqueOptions = useMemo(() => {
        if (field) {
        return [...new Set(options.filter(item => item[field] !== "")
            .map(item => item[field])
            .sort())];
        } else {
            return options.sort();
        }
    }, [options,field]);

    useEffect(() => {
        M.FormSelect.init(dropdownRef.current);
    }, [uniqueOptions,filterValue]);

    return (
        <div>
            {name && (<label className="black-text" style={{ fontWeight: "bold"}}> {name}
                {required && <span className="red-text" style={{ marginLeft: "5px", fontWeight: "bold", verticalAlign: "middle"}}>*</span>}
            </label>)}
            <select ref={dropdownRef} value={filterValue} onChange={e => onSelect(e.target.value)}>
                <option value={""} disabled={filterValue === ""}>{filterValue === "" ? "No Option Selected" : "Clear Selection" }</option>
                {uniqueOptions.map((value, index) => (
                    <option key={index} value={value}>{value}</option>
                ))}
            </select>
        </div>
    );
};

export default DropdownMenu;
